import { render, staticRenderFns } from "./ChatCardContent.vue?vue&type=template&id=769c8acc"
import script from "./ChatCardContent.vue?vue&type=script&lang=js"
export * from "./ChatCardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports